import React from 'react';
import WordList from './components/WordList';

function App() {
    return (
        <div className="min-h-screen bg-gray-50">
            <header className="bg-white shadow">
                <div className="max-w-7xl mx-auto py-6 px-4">
                    <h1 className="text-3xl font-bold text-gray-900">Word Book</h1>
                </div>
            </header>
            <main>
                <WordList />
            </main>
        </div>
    );
}

export default App; 